export const getBudgetFormStyles = (_, { palette = {} }) => ({
  budgetPerformanceTile: {
    width: 'max-content',
  },
  header: {
    marginBottom: 20,
  },
  'budgetPerformanceTile-m': {
    width: '100%',
  },
  'budgetPerformanceTile-s': {
    width: '100%',
  },
  formContainer: {
    maxWidth: 680,
    minWidth: 300,
    flex: '1',
    '& .bid-strategy-dropdown': {
      '& .ms-Dropdown': {
        maxWidth: 312,
      },
    },
    '& .title-item': {
      width: 'auto',
    },
  },
  budgetTitle: {
    fontSize: '18px',
    display: 'inline',
  },
  collapsiblePanel: {
    border: 'none',
    marginBottom: 'unset',
    backgroundColor: 'unset',
    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,

      '& .panel-title': {
        fontSize: 18,
        '& > a': {
          marginLeft: '-8px', // compensate 8px padding on the left of icon
          color: palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },

    '& .panel-collapse': {
      '& .panel-body': {
        padding: 0,
        overflow: 'hidden',
      },
    },
  },
  advancedBidStrategyContent: {
    '& .toggle-icon': {
      visibility: 'hidden',
    },
  },
});
